import type { useForm } from "hooks";
import type { BooleanSwitch, BootstrapableForm } from "types";
import type { OnboardingFormProps } from "ui/forms/ECommerce/Onboarding/types";

export const enum FormField {
    HasCreditLimitPolicy = 'hasCreditLimitPolicy',
    CreditLimitPolicyInput = 'creditLimitPolicyInput',
    FraudToolsInput = 'fraudToolsInput',
    WasTerminatedByAcquirer = 'wasTerminatedByAcquirer',
    TerminatedByAcquirerInput = 'terminatedByAcquirerInput',
    DoesCollectKyc = 'doesCollectKyc',
    DoesCollectKycViaOther = 'doesCollectKycViaOther',
    CollectKycViaOtherInput = 'collectKycViaOtherInput',
    HasFullTimeCustomerSupport = 'hasFullTimeCustomerSupport',
    FullTimeCustomerSupportInput = 'fullTimeCustomerSupportInput',
    CustomerSupportEmail = 'customerSupportEmail',
    RefundChargebackPolicies = 'refundChargebackPolicies',
    RefundChargebackPoliciesFileKey = 'refundChargebackPoliciesFileKey',
    SecurityRiskManagementInput = 'securityRiskManagementInput',
    OtherSecurityRiskInput = 'otherSecurityRiskInput',
};

export type OnboardingMarketingWebsiteAndSupport = {
    readonly [FormField.HasCreditLimitPolicy]: BooleanSwitch | null;
    readonly [FormField.CreditLimitPolicyInput]: string | null;
    readonly [FormField.FraudToolsInput]: string | null;
    readonly [FormField.WasTerminatedByAcquirer]: BooleanSwitch | null;
    readonly [FormField.TerminatedByAcquirerInput]: string | null;
    readonly [FormField.DoesCollectKyc]: BooleanSwitch | null;
    readonly [FormField.DoesCollectKycViaOther]: BooleanSwitch | null;
    readonly [FormField.CollectKycViaOtherInput]: string | null;
    readonly [FormField.HasFullTimeCustomerSupport]: BooleanSwitch | null;
    readonly [FormField.FullTimeCustomerSupportInput]: string | null;
    readonly [FormField.CustomerSupportEmail]: string | null;
    readonly [FormField.RefundChargebackPolicies]: string | null;
    readonly [FormField.RefundChargebackPoliciesFileKey]: string | null;
    readonly [FormField.SecurityRiskManagementInput]: string | null;
    readonly [FormField.OtherSecurityRiskInput]: string | null;
};

export type OnboardingMarketingWebsiteAndSupportBootstrapData = {};

export type OnboardingMarketingWebsiteAndSupportForm = Omit<
    BootstrapableForm<OnboardingMarketingWebsiteAndSupport, OnboardingMarketingWebsiteAndSupportBootstrapData>,
    | 'initialValues'
> & {
    readonly initialValues: OnboardingMarketingWebsiteAndSupport;
};

export type OnboardingMarketingWebsiteAndSupportProps =
    & OnboardingFormProps
    & OnboardingMarketingWebsiteAndSupportForm
    & ReturnType<typeof useForm<OnboardingMarketingWebsiteAndSupport>>;
